import { Skeleton } from 'antd'
import React from 'react'


interface Props{
    loading?: boolean
    children?: React.ReactNode
}

const SkeletonTag = ({loading, children}:Props) => {
  return (
    <>
    {loading? <Skeleton.Button active={true} size={"small"} />
    
    : children
    }
    </>

  )
}

export default SkeletonTag